import React, { FC } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useFixFlowProvider } from 'modules/contracts/components/FixFlow/FixFlowProvider'
import { useEmployeePersonalProvider } from 'modules/employees/components/blocks/EmployeePersonalProvider'

const Footer: FC = () => {
  const { onSubmit: onFixContract, form: contractForm, isSubmitting } = useFixFlowProvider()
  const {
    onSubmit,
    saving,
    isDirty: employeeIsDirty,
    isContractCategories,
  } = useEmployeePersonalProvider()
  const isDirty = employeeIsDirty || contractForm?.isDirty
  const disabled = isSubmitting || saving

  const onSubmitFixContract = () => {
    asyncAction(() => {
      return new Promise<void>((resolve, reject) => {
        onFixContract(() => {
          app.setFlash({
            type: 'correct',
            message: i18n.t('common.saved_successfully'),
          })
          resolve()
        })
      })
    })
  }

  const buttonText = disabled ? i18n.t('common.please_wait') : i18n.t('common.submit')
  return (
    <Box alignSelf="flexEnd">
      {isDirty && (
        <Button
          disabled={disabled}
          onClick={() => (isContractCategories ? onSubmitFixContract() : onSubmit())}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  )
}

export default observer(Footer)
